<template>
<div style="display: table;height:100%;width:100%">
    <div class="g-center">
      <h1 style="text-align:center">
        <p> 抱歉! 您的访问权限不足!</p>
      </h1>
    </div>
  </div>
</template>

<script>
	export default {
		name: "err404"
	}
</script>

<style scoped>
  .g-center{
    display: table-cell;

    vertical-align: middle;
  }
</style>